import { Outlet } from 'react-router-dom';
import s from './body.module.css';
import { Header } from '../header/header';

export const Body = () => {
  return (
    <div className={s.feature}>
      <Header />
      <div className={s.wrapper} id="body">
        <Outlet />
      </div>
    </div>
  );
};
